module.exports = __webpack_public_path__ + "static/img/hero-lady.67d4f5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hero-lady.png
// module id = mluO
// module chunks = 0